import { render, staticRenderFns } from "./Index-Bill.vue?vue&type=template&id=2e9e9f6c&scoped=true&"
import script from "./Index-Bill.vue?vue&type=script&lang=js&"
export * from "./Index-Bill.vue?vue&type=script&lang=js&"
import style0 from "./Index-Bill.vue?vue&type=style&index=0&id=2e9e9f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9e9f6c",
  null
  
)

export default component.exports